import { System } from '@app/core/resources/system';
import { SystemEnum } from '../../../../../shared/enums/system.enum';

export const generateBalanceSystem: () => System = (): System => {
    const system: System = new System();
    system.id = SystemEnum.balance;
    system.attributes.group_id = SystemEnum.balance;

    return system;
};
